<template>
    <div>
        <ul>
            <li>
                Essa Política de Privacidade aplica-se ao aplicativo Auto de Infração disponível em
                (br.gov.al.ima.auto.infracao)
                sendo obrigatória sua utilização como ferramenta para lavrar Auto de Infração/Termo de Embargo junto ao
                Instituto
                do Meio Ambiente – IMA/AL
            </li>
        </ul>
        <ul>
            <li class="mt-2 mb-2"><b>1. Aceitação da Política</b></li>
            <li>
                <b>1.1</b> Para usar os Serviços, o usuário deverá primeiro concordar com a Política e os Termos.
                Não é permitido o uso dos Serviços por parte do usuário se ele não aceitar os Política e os Termos.
            </li>
            <li>
                <b>1.2</b> O usuário pode aceitar os Política e Termos:
            </li>
            <ul>
                <li>
                    <b>(A)</b> clicando para aceitar ou concordar, no caso de essa opção ser disponibilizada pelo
                    IMA na interface do usuário do Serviço; ou
                </li>
                <li>
                    <b>(B)</b> usando efetivamente os Serviços. Nesse caso, o usuário compreende e aceita que o
                    IMA/AL considerará o uso dos Serviços uma aceitação dos Termos e Política a partir desse momento.
                </li>
            </ul>
        </ul>
        <ul>
            <li class="mt-4 mb-2"><b>2. Termos de Uso</b></li>
            <li>
                <b>2.1.</b> O usuário concorda em usar os Serviços somente para os fins permitidos: (a) pelos Termos; e (b)
                pelas leis, normas, práticas ou diretrizes geralmente aceitas nas jurisdições relevantes e aplicáveis.
            </li>
            <li>
                <b>2.2.</b> O usuário concorda em não participar de atividades que interfiram ou interrompam o funcionamento
                dos
                Serviços (ou servidores e redes conectados aos Serviços).
            </li>
            <li>
                <b>2.3.</b> O usuário concorda que será o único responsável por qualquer violação das suas obrigações no que
                diz
                respeito aos Termos e pelas consequências resultantes dessa violação.
            </li>
            <li>
                <b>2.4.</b> O procedimento no AUTO DE INFRAÇÃO, consiste nas seguintes 12 (doze) etapas:
                <ul>
                    <li>
                        <b>Etapa 1 –</b> Realizar Login;
                    </li>
                    <li>
                        <b>Etapa 2 –</b> Adicionar Auto de Infração;
                    </li>
                    <li>
                        <b>Etapa 3 –</b> Identificação do Autuado;
                    </li>
                    <li>
                        <b>Etapa 4 -</b> Localização da autuação;
                    </li>
                    <li>
                        <b>Etapa 5 –</b> Identificação do Motivo da Autuação;
                    </li>
                    <li>
                        <b>Etapa 6 –</b> Enquadramento da Infração;
                    </li>
                    <li>
                        <b>Etapa 7 –</b>Identificação da autuação (Leve, Grave, Gravíssima);
                        Porte da Empresa (Pequeno, Médio e Grande); Inserir valor da autuação;
                    </li>
                    <li>
                        <b>Etapa 8 –</b> Cadastrar pessoas envolvidas e coleta de assinaturas;
                    </li>
                    <li>
                        <b>Etapa 9 –</b> Cadastro de testemunhas e coleta de assinaturas;
                    </li>
                    <li>
                        <b>Etapa 10 –</b> Adicionar fiscais envolvidos;
                    </li>
                    <li>
                        <b>Etapa 11 –</b> Adicionar anexos (caso necessário);
                    </li>
                    <li>
                        <b>Etapa 12 –</b> Salvar Auto de Infração.
                    </li>
                </ul>
            </li>
        </ul>
        <ul>
            <p>
                <strong>3. Coleta e uso de informações</strong>
            </p>
            <p>
                <strong>3.1. Informações pessoais</strong>
            </p>
            <p>
                Ao usar nosso serviço não é solicitada nenhuma informação adicional de cadastro do usuário do Auto de
                Infração,
                Além disso não é fornecido nenhum formulário para cadastros de usuários do Auto de Infração no aplicativo
                visto que
                o uso do aplicativo é destinado a equipe do IMA/AL.

            <p>
                <strong>3.2. Informações Adicionais</strong>
            </p>
            Ao usar nosso aplicativo, para fornecer recursos de nosso aplicativo, podemos coletar, com sua permissão
            prévia:

            <p>
            <ul>
                <li>
                    - Informações sobre sua localização para registrar a localização do Auto de Infração;
                </li>
                <li>
                    - Imagens e outras informações da câmera e da biblioteca de fotos do seu dispositivo para anexar ao Auto
                    de Infração informações adicionais, como fotos do local ou de documentos;
                </li>
            </ul>
            </p>
            <li>
                Usamos essas informações para fornecer recursos de Nosso Serviço, para melhorar e personalizar Nosso
                Serviço. As informações podem ser carregadas nos servidores do IMA e/ou no servidor de um Provedor
                de Serviços ou podem simplesmente ser armazenadas em Seu dispositivo.
            </li>
            <li>
                Você pode habilitar ou desabilitar o acesso a essas informações a qualquer momento, por meio das
                configurações do seu dispositivo.
            </li>
            </p>
            <div>
                <p><strong>3.3 Serviços de terceiros</strong></p>

                <p>
                    O aplicativo usa serviços de terceiros que podem coletar
                    informações usadas para identificá-lo.
                </p>
                <p>
                    Link para a política de privacidade de provedores de serviços terceirizados usados pelo aplicativo:
                </p>
                <p>
                    <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google Play
                        Services</a>
                </p>
            </div>
            <div>
                <p><strong>3.4 Delete seus dados</strong></p>

                <p>
                    Você tem o direito de excluir ou solicitar que ajudemos a excluir os Dados Pessoais que coletamos sobre
                    você.
                </p>
                <p>
                    Nosso serviço pode permitir que você exclua certas informações sobre você de dentro do serviço.
                </p>
                <p>
                    Você também pode em contato conosco para solicitar acesso, corrigir ou excluir qualquer informação
                    pessoal que você nos forneceu.
                </p>
                <p>
                    Observe, no entanto, que podemos precisar reter certas informações quando tivermos uma obrigação legal
                    ou base legal para fazê-lo.
                </p>
                <p>
                    A solicitação de exclusão de dados pode ser feita através dos contatos oficiais do IMA/AL, disponíveis
                    na página
                    do IMA/AL: <a href="https://www2.ima.al.gov.br/fale-conosco/" target="_blank"
                        rel="noopener noreferrer">https://www2.ima.al.gov.br/fale-conosco/</a>
                </p>
            </div>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'LegalTermsAutoInfracao',
};
</script>

<style scoped lang="scss">
ul {
    list-style: none;
}

ul li {
    margin: 10px 0;
}
</style>
